(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDomains', TabDomains);

    TabDomains.$inject = ['$resource'];

    function TabDomains($resource) {
        var resourceUrl = 'api/tab-domains/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'list': {
                url:'api/tab-domains/list',
                method: 'GET',
                isArray: true},
            'listByUser': {
                url:'api/tab-domains/list-by-user',
                method: 'GET',
                isArray: true},
            'update': {method: 'PUT'},
            'requestToUpdateSettings': {
                url: 'api/tab-domains/update-settings',
                method: 'POST'
            },
            'byFleet': {
                url: 'api/tab-domains/fleets/:id',
                method: 'GET'
            },
            'byUser': {
                url: 'api/tab-domains/fleets',
                method: 'GET',
                isArray: true
            },
            'byUserLogin': {
                url: 'api/tab-domains/user/:login',
                method: 'GET',
                isArray: true
            },
            'myDomains': {
                url: 'api/my-domains',
                method: 'GET',
                isArray: true
            },
            'current' : {
                url: 'api/tab-domains/current-domain',
                method: 'GET'
            }
        });
    }
})();
